"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personsSchema = void 0;
const zod_1 = require("zod");
const person_schema_1 = require("./person.schema");
exports.personsSchema = zod_1.z.array(person_schema_1.personSchema).describe("List of persons");
